/** @jsx jsx */
import { React, classNames, polished, css, jsx } from 'jimu-core';
import { LoadingType } from './types';
import { getLoadingStyles, withStyles, withTheme } from 'jimu-theme';
const prefix = 'jimu';
/**
 * The `Loading` component can show loading state and disable interactions.
 *
 * ```ts
 * import { Loading } from 'jimu-ui'
 * ```
 */
export class _Loading extends React.PureComponent {
    constructor(props) {
        super(props);
        _Loading.count++;
        this.id = `jimu-loading-${_Loading.count}`;
    }
    getClassFromType(type, style) {
        /**
         * If have style of primary loading and secondary loading, won't add css class.
         * The reason is that style of these two loading types has conflicts with css class.
         */
        if (style && (type === LoadingType.Primary || type === LoadingType.Secondary)) {
            return '';
        }
        switch (type) {
            case LoadingType.Primary:
                return 'jimu-primary-loading';
            case LoadingType.Secondary:
                return 'jimu-secondary-loading';
            case LoadingType.Donut:
                return 'donut-loading';
            case LoadingType.Bar:
                return 'bar-loading';
            case LoadingType.DotsPrimary:
                return 'dot-loading primary';
            case LoadingType.DotsSecondary:
                return 'dot-loading secondary';
            default: //eslint-disable-line @typescript-eslint/switch-exhaustiveness-check
                return 'jimu-primary-loading';
        }
    }
    getStyle(width, height, type) {
        if (typeof width !== 'number' && typeof height !== 'number') {
            return null;
        }
        if (!type || type === LoadingType.Primary || type === LoadingType.Secondary) {
            const w = typeof width === 'number' ? `${width / 3}px` : (type === LoadingType.Primary ? '0.85rem' : '0.51rem');
            const h = typeof height === 'number' ? `${height}px` : (type === LoadingType.Primary ? '2rem' : '1.2rem');
            const c = type === LoadingType.Primary ? this.props.theme.sys.color.primary.main : polished.rgba(this.props.theme.ref.palette.neutral[700], 0.5);
            return getLoadingStyles(w, h, c, `${this.id}-${type}`);
        }
        else if (type === LoadingType.Donut) {
            const w = typeof width === 'number' ? `${width}px` : '2rem';
            const h = typeof height === 'number' ? `${height}px` : '2rem';
            const r = typeof width === 'number' ? `calc(50% - ${width / 2}px)` : 'calc(50% - 1rem)';
            const t = typeof width === 'number' ? `calc(50% - ${height / 2}px)` : 'calc(50% - 1rem)';
            return css `
        width: ${w} !important;
        height: ${h} !important;
        right: ${r} !important;
        top: ${t} !important;
      `;
        }
        else if (type === LoadingType.Bar) {
            const w = typeof width === 'number' ? `${width}px` : '100%';
            const h = typeof height === 'number' ? `${height}px` : '2px';
            return css `
        width: ${w} !important;
        height: ${h} !important;
      `;
        }
        return null;
    }
    render() {
        const classes = classNames(`${prefix}-loading`, this.props.className);
        const style = this.getStyle(this.props.width, this.props.height, this.props.type);
        const classFromType = this.getClassFromType(this.props.type, style);
        return (jsx("div", { className: classes },
            jsx("div", { className: `justify-content-center align-content-center ${classFromType}`, css: style })));
    }
}
_Loading.count = 0;
/**
 * The `Loading` component can show loading state and disable interactions.
 *
 * ```ts
 * import { Loading } from 'jimu-ui'
 * ```
 */
export const Loading = withStyles(withTheme(_Loading), 'Loading');
